import React from 'react'

import { datadogRum } from '@datadog/browser-rum'
import { Modal } from '@gousto-internal/citrus-react'

import type { RecipeQueryResponse } from '@library/api-menu-experience'
import type { RecipeCoreId, RecipeUUID } from '@library/menu-service'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { DetailContent as DetailContentExperience } from 'routes/Menu/MenuExperience/Detail/DetailContent'

import { DetailContent } from './DetailContent'

import css from './Detail.css'

type DetailProps = {
  uuid: RecipeUUID
  coreId: RecipeCoreId
  title: string
  showOverlay: boolean
  isExperienceDetailEnabled: boolean
  error: boolean
  loading: boolean
  recipe: MenuRecipe | RecipeQueryResponse | null
  position?: string
  reload: () => void
  onClose: () => void
}

const getAllergenCount = (recipe: MenuRecipe | RecipeQueryResponse | null) => {
  if (!recipe) {
    return 0
  }

  if (recipe.responseType === 'experience') {
    return recipe.allergens?.list.length ?? 0
  }

  return recipe.allergens?.length ?? 0
}

export const Detail = ({
  uuid,
  coreId,
  title,
  showOverlay,
  isExperienceDetailEnabled,
  error,
  loading,
  recipe,
  reload,
  onClose,
  position,
}: DetailProps) => (
  <Modal
    name="recipe-detail-modal"
    isOpen={showOverlay}
    onAfterOpen={() => {
      datadogRum.addAction('view_menu_recipe_detail', {
        recipe_id: recipe?.id,
        position,
        allergen_count: getAllergenCount(recipe),
      })
    }}
    onRequestClose={onClose}
    overlayClassName={css.overlay}
  >
    {isExperienceDetailEnabled ? (
      <DetailContentExperience
        uuid={uuid}
        coreId={coreId}
        title={title}
        error={error}
        loading={loading}
        recipe={recipe?.responseType === 'experience' ? recipe : null}
        reload={reload}
        onClose={onClose}
        position={position}
      />
    ) : (
      <DetailContent
        uuid={uuid}
        coreId={coreId}
        title={title}
        error={error}
        loading={loading}
        recipe={recipe?.responseType === 'v3' ? recipe : null}
        reload={reload}
        onClose={onClose}
        position={position}
      />
    )}
  </Modal>
)
